import React, { useState } from 'react';

interface NavDef {
  icon: React.FC<{ active: boolean }>;
  activeIcon: React.FC<{ active: boolean }>;
  label: string;
}

interface BottomNavBarProps {
  currentIndex: number;
  onTap: (index: number) => void;
}

const PeopleOutline: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? 'var(--color-primary)' : 'none'} stroke={active ? 'var(--color-primary)' : 'var(--color-on-surface-variant)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const CalendarIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? 'var(--color-primary)' : 'none'} stroke={active ? 'var(--color-primary)' : 'var(--color-on-surface-variant)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const AssignmentIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--color-primary)' : 'var(--color-on-surface-variant)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
);
const SettingsIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--color-primary)' : 'var(--color-on-surface-variant)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const NAV_ITEMS: NavDef[] = [
  { icon: PeopleOutline, activeIcon: PeopleOutline, label: 'Therapists' },
  { icon: CalendarIcon, activeIcon: CalendarIcon, label: 'Upcoming' },
  { icon: AssignmentIcon, activeIcon: AssignmentIcon, label: 'Assessments' },
  { icon: SettingsIcon, activeIcon: SettingsIcon, label: 'Settings' },
];

const BottomNavBar: React.FC<BottomNavBarProps> = ({ currentIndex, onTap }) => {
  return (
    <div className="bottom-nav-wrap">
      <div className="bottom-nav">
        {NAV_ITEMS.map((item, i) => {
          const active = i === currentIndex;
          const Icon = item.icon;
          return (
            <div
              key={item.label}
              className={`nav-item ${active ? 'active' : ''}`}
              onClick={() => onTap(i)}
              role="button"
              aria-label={item.label}
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && onTap(i)}
            >
              {/* Ripple */}
              <div className="nav-item-icon">
                <Icon active={active} />
              </div>
              <div className="nav-item-label">{item.label}</div>
              <div className="nav-item-dots">
                {[0, 1, 2].map(d => (
                  <div key={d} className="nav-dot" style={{ transitionDelay: `${d * 55}ms` }} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavBar;
